// removed by extract-text-webpack-plugin
module.exports = {"videoContainer":"SqiA_11TZncg_pIyrLYjS","marquee":"_2VoGbKV_BXOFW24J4x0Cku","slider":"_2J5rE0KxNqRQzgb_PaNrDv","sliderContent":"_2vDATn-hflikU_aG7AUDNJ","sliderRacer":"_2o80-H6JU7g7BTsCv06RZg","sliderText":"D29XhxTZ_eluaXk2yOJ7K","iframe":"_2a8ziBsmDyEobHKRC2vhGf","racerIconContainer":"_1GSfvwHLy06lBrIH0puorK","racerNumber":"_3QCZ_idQbI9PDuRgaIuX15","racerIcon":"_2PMQCrpRPOHmODDviA7PGO"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/desktop/css/videoPlayer.css
// module id = 1058
// module chunks = 0